import { Quota } from "./quota";
import { ApiText } from "../api-text";
import { User } from './user';
import { LicenceRoleType } from '@enums/licence-role-type.enum';

export class UserRole {
    code: LicenceRoleType;
    text: ApiText;
    userQuota?: Quota;

    users?: User[];

    constructor(role: UserRole, maxUsers: number) {
        this.code = role.code;
        this.text = role.text;
        this.userQuota = new Quota(maxUsers);
    }
}
